export default (name) => ({
  readingType: {
    name,
  },
})
